module.exports = __webpack_public_path__ + "img/text.7f08e4ae.png";